import { ChangeDetectionStrategy, Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { JsonFormsAngularService, JsonFormsControl } from '@jsonforms/angular';
import { and, isEnumControl, optionIs, RankedTester, rankWith } from '@jsonforms/core';
import { Store } from '@ngrx/store';
import { AppState } from '@app/state/app.state';
import { configurationSelector } from '@app/state/app.selectors';

@Component({
  styles: [
    `
      .mat-radio-button ~ .mat-radio-button {
        margin-left: 16px;
      }
    `,
  ],
  selector: 'ContractTypeControlRenderer',
  template: `
    <div [fxHide]="hidden || options.length <= 1">
      <mat-radio-group
        aria-labelledby="example-radio-group-label"
        class="example-radio-group"
        (change)="onChange($event)"
        [disabled]="!isEnabled()"
        [id]="id"
      >
        <mat-radio-button
          class="example-radio-button"
          *ngFor="let option of options ?? this.scopedSchema.enum"
          [value]="option"
          [checked]="isChecked(option)"
        >
          {{ option }}
        </mat-radio-button>
      </mat-radio-group>
      <mat-hint class="mat-caption" *ngIf="shouldShowUnfocusedDescription()">{{ description }}</mat-hint>
      <mat-error class="mat-caption">{{ error }}</mat-error>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ContractTypeControlRenderer extends JsonFormsControl {
  public options: string[] = [];

  constructor(
    jsonformsService: JsonFormsAngularService,
    private changeDetectorRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    super(jsonformsService);

    this.store.select(configurationSelector).subscribe((config) => {
      if (config.supplierConfiguration.enableDocuSignContracting) {
        this.options.push('DocuSign');
      }
      if (config.supplierConfiguration.enablePdfContracting) {
        this.options.push('PDF');
      }
      if (!config.supplierConfiguration.enableDocuSignContracting && !config.supplierConfiguration.enablePdfContracting) {
        this.options.push('None');
      }
    });
  }

  getEventValue = (event: any) => event.value;

  isChecked(option) {
    // To default to first radio button but kick off jsonforms that the value changed! Dirty hack!
    if (!this.data || !this.options.includes(this.data)) {
      this.data = this.options[0];
      this.onChange({ value: this.options[0] });
      return true;
    }
    return this.data && this.data === option;
  }

  mapAdditionalProps() {
    this.changeDetectorRef.markForCheck();
  }
}

export const ContractTypeControlRendererTester: RankedTester = rankWith(10, and(optionIs('format', 'radio'), isEnumControl));
